// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"e5b0ec1f","42":"c143fe3b","84":"2191a412","203":"0721d330","453":"bd96e54e","716":"e50987aa","764":"7ed3cb43"}[chunkId] + ".chunk.js";
};